<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import {
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		TipoPerfil,
		verificarSessionStorage
	} from '../../utils';
	import TBox from '../templates/TBox.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let botaoEnvioDesabilitadoPasso1 = true;
	let botaoEnvioDesabilitadoPasso2 = true;

	let divInformacoesAvaliador, avaliadorSelecionadoHtml;
	let divInformacoesProjeto, projetoOuApresentacaoSelecionadoHTML;

	let codigoProjetoOuIdApresentacao = "", cpfAvaliador = "";
	let distribuindoProjetos;
	let buscaFinalizada = false;

	onMount(async () => {
		if (!verificarSessionStorage('AVAL_TOKEN'))
			replace("/login");

		divInformacoesAvaliador = document.getElementById('boxInformacoesAvaliador');
		divInformacoesProjeto = document.getElementById('boxInformacoesProjetoOuApresentacao');
	});

	const esconderPartesMatricula = (matricula) => matricula.replace(/\d(?<=\d{4})\d(?=\d{2})/g, "##");

	async function buscarProjetoPorCodigo(event) {
		if (codigoProjetoOuIdApresentacao == "") return;

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Buscando projeto...',
		});
			
		// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
		const resposta = await fetch(API('projetos/busca'), {
			method: 'POST',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				campo: 'codigo',
				termo: codigoProjetoOuIdApresentacao
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
			
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {
			let objetoRetornado = json.dados[0];

			projetoOuApresentacaoSelecionadoHTML = `
				<p>Título: <strong>${objetoRetornado.titulo}</strong></p>
				<p>Area atuação: <strong>${objetoRetornado.alocacao}</strong></p>
				<p>Modalidade: <strong>${objetoRetornado.modalidade}</strong></p>
				<p>Unidade: <strong>${objetoRetornado.unidade}</strong></p>
			`;

			botaoEnvioDesabilitadoPasso2 = false;
			distribuindoProjetos = true;
			buscaFinalizada = true;
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			feedbackUsuario.push('Projeto não encontrado.');
		} else {
			feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}

	async function buscarApresentacaoPorId(event) {
		if (codigoProjetoOuIdApresentacao == "") return;

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Buscando apresentação...',
		});
			
		// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
		const resposta = await fetch(API('apresentacoes/busca'), {
			method: 'POST',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				campo: 'id',
				termo: codigoProjetoOuIdApresentacao
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
			
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {
			let objetoRetornado = json.dados;
			
			projetoOuApresentacaoSelecionadoHTML = `
				<p>Inscrição: <strong>${objetoRetornado.id_zerofill}/${objetoRetornado.projeto.codigo}</strong></p>
				<p>Data inscrição: <strong>${objetoRetornado.data_criacao}</strong></p>
				<p>Trabalho: <strong>${objetoRetornado.projeto.titulo}</strong></p>
			`;

			botaoEnvioDesabilitadoPasso2 = false;
			distribuindoProjetos = false;
			buscaFinalizada = true;
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			feedbackUsuario.push('Apresentação não encontrada.');
		} else {
			feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}

	async function buscarAvaliadorPorCPF(event) {
		if (cpfAvaliador == "") return;

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Buscando avaliador ...',
		});
			
		// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
		const resposta = await fetch(API('buscar-avaliador-por-cpf'), {
			method: 'POST',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				perfil: TipoPerfil.AVALIADOR,
				cpf: cpfAvaliador,
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
			
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			let avaliadorRetornado = json.dados;

			avaliadorSelecionadoHtml = `
				<p>Avaliador: <strong>${avaliadorRetornado.nome}</strong></p>
				<p>Matrícula: <strong>${esconderPartesMatricula(avaliadorRetornado.matricula)}</strong></p>
				<p>Unidade: <strong>${avaliadorRetornado.unidade}</strong></p>
				<p>Área interesse: <strong>${avaliadorRetornado.area_interesse}</strong></p>
			`;

			botaoEnvioDesabilitadoPasso1 = false;
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			feedbackUsuario.push('Usuário não encontrado com o CPF informado.');
		} else {
			feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}

	async function submeterFormulario(event) {
		if (distribuindoProjetos == undefined) {
			alert('O tipo de objeto a ser distribuído não foi definido. Operação não executada!');
			return;
		}

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Distribuindo projeto/apresentação (operação manual) ...',
		});
		
		// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
		const resposta = await fetch(API('distribuicao-manual'), {
			method: 'POST',
			headers: cabecalhoPadraoRequisicao(distribuindoProjetos),
			body: JSON.stringify({
				codigoProjetoOuIdApresentacao: codigoProjetoOuIdApresentacao,
				cpfAvaliador: cpfAvaliador
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
			
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {		
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Tudo certo!',
				conteudo: json?.mensagem
			});

			replace('/painel/distribuicao');
		} else {
			feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}
</script>

<TBox 
	titulo="Distribuição Manual" 
	subtitulo="Informe os dados abaixo para prosseguir" 
	largura="8" 
	deslocamento="2" 
	icone="distribuicao">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<p>Digite o <strong>código completo do projeto</strong> ou <strong>número da inscrição da apresentação</strong> sem o ano (<small class="is-info">Ex.: inscrição 000123/2022, digite apenas 000123</small>) que deseja distribuir:</p>
		<br>

		<div class="columns">
			<div class="column">
				<div class="field has-addons">
					<div class="control is-expanded">
						<input 
							bind:value={codigoProjetoOuIdApresentacao}
							name="codigo"
							type="tel" 
							pattern="[0-9]*"
							maxlength="16"
							placeholder="Somente números..." 
							class="input is-large is-primary" required>
					</div>
				</div>
			</div>
		</div>
		
		<div class="columns">
			<div class="column">
				<div class="control">
					<button class="button is-info is-large is-fullwidth" on:click|preventDefault={buscarProjetoPorCodigo} disabled={buscaFinalizada}>Buscar Projeto</button>
				</div>
			</div>
			<div class="column">
				<div class="control">
					<button class="button is-success is-large is-fullwidth" on:click|preventDefault={buscarApresentacaoPorId} disabled={buscaFinalizada}>Buscar Apresentação</button>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<span class="tag">RESUMO DO PROJETO OU APRESENTAÇÃO:</span>
				<div class="box" id="boxInformacoesProjetoOuApresentacao">
					{#if projetoOuApresentacaoSelecionadoHTML}
					{@html projetoOuApresentacaoSelecionadoHTML}
					{:else}
					<p>Ao clicar em buscar um resumo do projeto ou apresentação será exibido aqui.</p>
					{/if}
				</div>
			</div>
		</div>

		<hr>

		<p>Digite o CPF do avaliador a ser atribuído:</p>
		<br>
		
		<div class="columns">
			<div class="column">
				<div class="field has-addons">
					<div class="control is-expanded">
						<input 
							bind:value={cpfAvaliador}
							name="cpf"
							type="tel" 
							pattern="[0-9]*"
							maxlength="11"
							placeholder="Somente números..." 
							class="input is-large is-primary" required>
					</div>
					<div class="control">
						<button class="button is-info is-large" on:click|preventDefault={buscarAvaliadorPorCPF}>Buscar</button>
					</div>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<span class="tag">RESUMO DO(A) AVALIADOR(A):</span>
				<div class="box" id="boxInformacoesAvaliador">
					{#if avaliadorSelecionadoHtml}
					{@html avaliadorSelecionadoHtml}
					{:else}
					<p>Ao clicar em buscar um resumo do(a) avaliador(a) será exibido aqui.</p>
					{/if}
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/painel/distribuicao" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						disabled={botaoEnvioDesabilitadoPasso1 && botaoEnvioDesabilitadoPasso2}
						class="button is-danger is-medium is-fullwidth">
						Executar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>